// components/TextInput.jsx

const TextInput = ({
  name,
  type,
  placeholder,
  value,
  onChange,
  required,
  disabled,
  className,
  readOnly,
  sx = {},
  ...restProps
}) => {
  const { theme } = localStorage.getItem("theme");

  return (
    <input
      name={name}
      type={type}
      placeholder={placeholder}
      onChange={onChange}
      value={value}
      disabled={disabled}
      required={required ? true : false}
      className={`bg-[--bg-color] border border-[--bg-tbl-header] p-2  text-sm w-full ${
        className || ""
      }`}
      style={sx}
      readOnly={readOnly}
      {...restProps}
    />
  );
};

export default TextInput;
